// Umbrales y horarios del Home VL.

/** Hora a la que abre el piso VL; supuesto, ninguna fuente declara la apertura todavía. */
export const FLOOR_OPENING_HOUR = 10;

/** Hora a la que cierra el piso VL. */
export const FLOOR_CLOSING_HOUR = 21;

/** Tienda rezagada: avance de su meta del día por debajo de esta fracción. */
export const STORE_BEHIND_THRESHOLD = 0.3;

/** Vendedor bajo: avance de su meta del día por debajo de esta fracción. */
export const SELLER_LOW_THRESHOLD = 0.2;

/** Horas de piso abierto antes de marcar a una tienda rezagada o a un vendedor bajo. */
export const LOW_PROGRESS_MIN_FLOOR_HOURS = 4;

/** Máximo de alertas de vendedor bajo en la tarjeta. */
export const SELLER_LOW_MAX_ALERTS = 3;

/** Promo por vencer: días de calendario que le quedan, de 0 a este valor. */
export const PROMO_EXPIRING_MAX_DAYS = 3;
